<template>
  <div class="country-switch clearfix">
    Estás en: Cumplo <b>México</b> Ekscelenko
  </div>
</template>

<script>
export default {
  name: 'CountrySwitch',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>

.country-switch {
  padding: .5em 1em .2em;
  font-size: .8em;
  height: 30px;
  color: #fff;
  background-color: #3A454E;

  .box-flags {
    float: right;

    .flag {
      display: inline-block;
      max-height: 10px;
      width: 20px;
      margin: 0 .2em;
    }
  }

  .-half {
    float: left;
    width: 50%;
  }

}

</style>



// WEBPACK FOOTER //
// src/partials/CountrySwitch.vue